import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useAppContext } from '../app/app-context.hoc.js';
const withHelmet = (Component) => {
    const WithHelmet = (props) => {
        const { helmetContext } = useAppContext();
        return (React.createElement(HelmetProvider, { context: helmetContext },
            React.createElement(Component, Object.assign({}, props))));
    };
    return WithHelmet;
};
export { withHelmet };
